import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-2 font-bold text-[14px]" }, "Información personal", -1)
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-[14px] mt-3 mb-2" }, "Información bancaria", -1)
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "flex lg:flex-row flex-col gap-2" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-[14px] mt-3 mb-2" }, " Información de la empresa representada ", -1)
const _hoisted_12 = { class: "flex flex-col gap-2" }
const _hoisted_13 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-[14px] mt-3 mb-2" }, " Información de personería ", -1)
const _hoisted_16 = { class: "flex flex-col gap-2" }
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = {
  key: 1,
  class: "grid grid-cols-2 gap-2"
}
const _hoisted_19 = { class: "font-bold text-[14px] mt-3 mb-2 text-red-500" }
const _hoisted_20 = ["disabled"]

import { computed, Ref, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import Swal from "sweetalert2";

import { isNullOrEmpty, makeRandomString, validateRut } from "@/services/utils";
import { AuthService } from "@/services/auth/AuthService";
import { bankAccountTypes } from "@/services/auth/types";

import { useAuthStore } from "@/stores/auth";
import useBankStore from "@/stores/banks";

import NewModal from "@/components/atoms/NewModal.vue";
import TextField from "@/components/atoms/TextField.vue";
import Selector from "@/components/atoms/Selector.vue";
import SelectorSimpler from "../atoms/SelectorSimpler.vue";

type userResponse = {
  detail: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'NewShareholderModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:visible", "reload"],
  setup(__props, { emit }) {

const props = __props;



const isVisible = computed(() => props.visible);



const flow = ref(["year", "month", "calendar"]);

const bankStore = useBankStore();

const { bankListable: banks } = storeToRefs(bankStore);

watch(isVisible, () => {
  bankStore.fetchBanks();
});

const authStore = useAuthStore();
const authService = new AuthService();
const editedTitularRut = ref<boolean>(false);
const editedTitularEmail = ref<boolean>(false);
const loading = ref(false);
const hasError = ref(false);
const textError = ref("");

const investorNumberA = ref<number>(0);
const investorNumberB = ref<number>(0);

// Información basica
const firstName = ref("");
const lastName = ref("");
const email = ref("");
const phone = ref("");
const rut = ref("");
const gender = ref("");

const address = ref("");

const bank = ref({
  key: "",
  value: "",
});

const county = ref("");
const region = ref("");
const accountType = ref("");
const accountNumber = ref("");
const ownerName = ref("");
const ownerRut = ref("");
const bankEmail = ref("");

const businessName = ref("");
const companyAddress = ref("");
const companyRut = ref("");
const notary = ref("");
const notaryCity = ref("");
const repertoireNumber = ref("");
const writingDate: Ref<Date | null> = ref(null);

const password = ref(makeRandomString(6));

// Indica si el formulario tiene algun error de dato o valor requerido
const formHasError = computed(() => {
  const requiredFields = [
    firstName.value,
    lastName.value,
    email.value,
    rut.value,
    address.value,

    // bank
    bank.value.value,
    bank.value.key,

    accountType.value,
    accountNumber.value,
    ownerName.value,
    ownerRut.value,
    bankEmail.value,
    password.value,
  ];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [
    countyFieldHasError.value,
    regionFieldHasError.value,
    firstNameFieldHasError.value,
    lastNameFieldHasError.value,
    rutFieldHasError.value,
    emailFieldHasError.value,
    bankNameFieldHasError.value,
    bankCodeFieldHasError.value,
    accountTypeFieldError.value,
    accountFieldHasError.value,
    ownerFieldHasError.value,
    ownerRutFieldHasError.value,
    bankEmailFieldHasError.value,
    companyRutFieldHasError.value,
    addressFieldHasError.value,
    notaryHasError.value,
    notaryCityHasError.value,
    writingDateHasError.value,
    repertoireNumberHasError.value,
    companyAddressHasError.value,
    county.value,
    region.value,
    genderFieldHasError.value,
  ];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});

const firstNameFieldHasError = computed(() => {
  return isNullOrEmpty(firstName.value);
});

const lastNameFieldHasError = computed(() => {
  return isNullOrEmpty(lastName.value);
});

const rutFieldHasError = computed(() => {
  return isNullOrEmpty(rut.value) || !validateRut(rut.value);
});

const emailFieldHasError = computed(() => {
  return isNullOrEmpty(email.value) || !email.value.includes("@");
});

const bankNameFieldHasError = computed(() => {
  return isNullOrEmpty(bank.value.value);
});

const bankCodeFieldHasError = computed(() => {
  return isNullOrEmpty(bank.value.key);
});

const accountTypeFieldError = computed(() => {
  return isNullOrEmpty(accountType.value);
});

const accountFieldHasError = computed(() => {
  return isNullOrEmpty(accountNumber.value);
});

const ownerFieldHasError = computed(() => {
  return isNullOrEmpty(ownerName.value);
});

const ownerRutFieldHasError = computed(() => {
  return isNullOrEmpty(ownerRut.value) || !validateRut(ownerRut.value);
});

const bankEmailFieldHasError = computed(() => {
  return isNullOrEmpty(bankEmail.value) || !bankEmail.value.includes("@");
});

const companyRutFieldHasError = computed(() => {
  const isEmpty = isNullOrEmpty(companyRut.value);
  const isInvalidRut = !validateRut(companyRut.value);
  const isRequiredAndEmpty = businessDataAdded.value && isEmpty;
  return isRequiredAndEmpty || (businessDataAdded.value && isInvalidRut);
});

const businessNameHasError = computed(() => {
  const isEmpty = isNullOrEmpty(businessName.value);
  const isRequiredAndEmpty = businessDataAdded.value && isEmpty;
  return isRequiredAndEmpty;
});

const companyAddressHasError = computed(() => {
  const isEmpty = isNullOrEmpty(companyAddress.value);
  const isRequiredAndEmpty = businessDataAdded.value && isEmpty;
  return isRequiredAndEmpty;
});

const addressFieldHasError = computed(() => {
  return isNullOrEmpty(address.value);
});

const businessDataAdded = computed(() => {
  return (
    !isNullOrEmpty(companyRut.value) ||
    !isNullOrEmpty(companyAddress.value) ||
    !isNullOrEmpty(businessName.value)
  );
});

const writingDateHasError = computed(() => {
  return businessDataAdded.value && !writingDate.value;
});

const notaryHasError = computed(() => {
  return businessDataAdded.value && isNullOrEmpty(notary.value);
});
const notaryCityHasError = computed(() => {
  return businessDataAdded.value && isNullOrEmpty(notaryCity.value);
});

const repertoireNumberHasError = computed(() => {
  return businessDataAdded.value && isNullOrEmpty(repertoireNumber.value);
});

const genderFieldHasError = computed(() => {
  return isNullOrEmpty(gender.value);
});
const countyFieldHasError = computed(() => {
  return isNullOrEmpty(county.value);
});
const regionFieldHasError = computed(() => {
  return isNullOrEmpty(region.value);
});
watch(rut, (curr) => {
  if (!editedTitularRut.value) {
    ownerRut.value = curr;
  }
});
watch(email, (curr) => {
  if (!editedTitularEmail.value) {
    bankEmail.value = curr;
  }
});

/**
 * Envia una solicitud al backend para registrar al nuevo accionista
 */
async function registerShareholder() {
  // TODO: Agregar modal de comprobación y aviso de que se enviara el email de registro
  if (!authStore.token) return;

  loading.value = true;
  hasError.value = false;
  const response = await authService.registerShareholder(
    authStore.token,
    firstName.value,
    lastName.value,
    email.value,
    phone.value,
    rut.value,
    address.value,
    bank.value.value,
    bank.value.key,
    accountType.value,
    accountNumber.value,
    ownerName.value,
    ownerRut.value,
    bankEmail.value,
    businessName.value,
    companyAddress.value,
    companyRut.value,
    writingDate.value,
    notary.value,
    notaryCity.value,
    repertoireNumber.value,
    password.value,
    gender.value == "Mujer",
    county.value,
    region.value,
    investorNumberA.value,
    investorNumberB.value
  );
  loading.value = false;

  if (!response.success) {
    let userResponseData = response.data as userResponse;
    textError.value = userResponseData.detail;
    hasError.value = true;

    return;
  }
  Swal.fire("¡Listo!", "El accionista se ha creado con éxito", "success");
  emit("reload");
  emit("update:visible", false);
}

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createBlock(NewModal, {
    title: "Registro de nuevo accionista",
    visible: __props.visible,
    "onUpdate:visible": _cache[24] || (_cache[24] = (e) => _ctx.$emit('update:visible', e))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: firstName.value,
            "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
            type: "text",
            name: "firstName",
            label: "Nombres",
            "has-error": firstNameFieldHasError.value,
            "error-message": "Este campo es requerido",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: lastName.value,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((lastName).value = $event)),
            type: "text",
            name: "lastName",
            "has-error": lastNameFieldHasError.value,
            "error-message": "Este campo es requerido",
            label: "Apellidos",
            "hide-details": ""
          }, null, 8, ["model", "has-error"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: rut.value,
            "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((rut).value = $event)),
            type: "text",
            name: "rut",
            label: "Rut",
            "has-error": rutFieldHasError.value,
            "error-message": "Este campo es requerido y debe ser un rut válido. No debe contar con puntos pero si con guión y número verificador (Ej: 12345678-9)",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(Selector, {
            class: "col-span-2 lg:col-span-1",
            model: gender.value,
            "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((gender).value = $event)),
            items: ['Mujer', 'Hombre'],
            label: "Genero",
            "has-error": genderFieldHasError.value,
            "error-message": "Debe indicar si el representante o el accionista es hombre o mujer. Será utilizado como referencia para la generación de contratos."
          }, null, 8, ["model", "has-error"])
        ]),
        _createVNode(TextField, {
          model: address.value,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((address).value = $event)),
          type: "text",
          name: "address",
          label: "Dirección particular",
          "has-error": addressFieldHasError.value,
          "error-message": "Debe ingresar la dirección del cliente",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: region.value,
          "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((region).value = $event)),
          type: "text",
          name: "region",
          label: "Región",
          "has-error": regionFieldHasError.value,
          "error-message": "Debe ingresar la región del cliente",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: county.value,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((county).value = $event)),
          type: "text",
          name: "county",
          label: "Comuna",
          "has-error": countyFieldHasError.value,
          "error-message": "Debe ingresar la comuna del cliente",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: email.value,
            "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((email).value = $event)),
            type: "text",
            name: "email",
            label: "Correo eléctronico",
            "has-error": emailFieldHasError.value,
            "error-message": "Es necesario ingresar un correo electrónico valido.",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: phone.value,
            "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((phone).value = $event)),
            type: "number",
            name: "phone",
            label: "Teléfono",
            "hide-details": ""
          }, null, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: investorNumberA.value,
            "onUpdate:model": _cache[9] || (_cache[9] = ($event: any) => ((investorNumberA).value = $event)),
            type: "number",
            name: "investorNumberA",
            label: "ID A",
            "has-error": false,
            "error-message": "El número de accionista ingresado no es valido",
            "hide-details": ""
          }, null, 8, ["model"]),
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: investorNumberB.value,
            "onUpdate:model": _cache[10] || (_cache[10] = ($event: any) => ((investorNumberB).value = $event)),
            type: "number",
            name: "investorNumberB",
            label: "ID B",
            "has-error": false,
            "error-message": "El número de accionista ingresado no es valido",
            "hide-details": ""
          }, null, 8, ["model"])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(SelectorSimpler, {
            label: "Banco",
            class: "w-full",
            "has-error": bankNameFieldHasError.value,
            "error-message": "Es necesario indicar el banco del cliente",
            items: _unref(banks),
            selected: bank.value,
            "onUpdate:model": _cache[11] || (_cache[11] = 
              (item) => {
                if (bank.value) {
                  bank.value = item;
                }
              }
            )
          }, null, 8, ["has-error", "items", "selected"]),
          _createVNode(Selector, {
            label: "Tipo de cuenta",
            class: "w-full",
            model: accountType.value,
            "onUpdate:model": _cache[12] || (_cache[12] = ($event: any) => ((accountType).value = $event)),
            "has-error": accountTypeFieldError.value,
            "error-message": "Es necesario indicar el tipo de cuenta del client",
            items: _unref(bankAccountTypes)
          }, null, 8, ["model", "has-error", "items"])
        ]),
        _createVNode(TextField, {
          model: accountNumber.value,
          "onUpdate:model": _cache[13] || (_cache[13] = ($event: any) => ((accountNumber).value = $event)),
          type: "text",
          name: "accountNumber",
          "has-error": accountFieldHasError.value,
          "error-message": "Es necesario indicar el número de la cuenta bancaria",
          label: "Número de cuenta",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(TextField, {
          model: ownerName.value,
          "onUpdate:model": _cache[14] || (_cache[14] = ($event: any) => ((ownerName).value = $event)),
          type: "text",
          name: "ownerName",
          "has-error": ownerFieldHasError.value,
          "error-message": "Es necesario indicar el nombre del propietario de la cuenta bancaria",
          label: "Nombre del titular",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: ownerRut.value,
            "onUpdate:model": _cache[15] || (_cache[15] = ($event: any) => ((ownerRut).value = $event)),
            type: "text",
            name: "ownerRut",
            "has-error": ownerRutFieldHasError.value,
            "error-message": "Debe ingresar el rut del propietario de la cuenta bancaria en un formato correcto. No use puntos e indique el digito verificador (Ej: 12345678-9)",
            label: "Rut del titular",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: bankEmail.value,
            "onUpdate:model": _cache[16] || (_cache[16] = ($event: any) => ((bankEmail).value = $event)),
            type: "text",
            name: "bankEmail",
            "has-error": bankEmailFieldHasError.value,
            "error-message": "Debe ingresar un email de aviso para las transferencias",
            label: "Email de aviso",
            "hide-details": ""
          }, null, 8, ["model", "has-error"])
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: businessName.value,
            "onUpdate:model": _cache[17] || (_cache[17] = ($event: any) => ((businessName).value = $event)),
            type: "text",
            name: "businessName",
            label: "Razón social",
            "has-error": businessNameHasError.value,
            "error-message": "Es necesario agregar el nombre de la empresa",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(TextField, {
            class: "col-span-2 lg:col-span-1",
            model: companyRut.value,
            "onUpdate:model": _cache[18] || (_cache[18] = ($event: any) => ((companyRut).value = $event)),
            type: "text",
            name: "companyRut",
            "has-error": companyRutFieldHasError.value,
            "error-message": "El rut ingresado no es valido. No utilice puntos e indique el digito verificador (Ej: 12345678-9)",
            label: "Rut",
            "hide-details": ""
          }, null, 8, ["model", "has-error"])
        ]),
        _createVNode(TextField, {
          model: companyAddress.value,
          "onUpdate:model": _cache[19] || (_cache[19] = ($event: any) => ((companyAddress).value = $event)),
          type: "text",
          name: "companyAddress",
          label: "Dirección",
          "has-error": companyAddressHasError.value,
          "error-message": "Debe ingresar la dirección de la empresa",
          "hide-details": ""
        }, null, 8, ["model", "has-error"])
      ]),
      (businessDataAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(TextField, {
                  model: notary.value,
                  "onUpdate:model": _cache[20] || (_cache[20] = ($event: any) => ((notary).value = $event)),
                  type: "text",
                  name: "notary",
                  label: "Notaria",
                  "has-error": notaryHasError.value,
                  "error-message": "Debe ingresar el nombre de la notaría de la empresa",
                  placeholder: "Ej: 'Santiago de don Luis Fuentes Ardiles'",
                  "hide-details": ""
                }, null, 8, ["model", "has-error"]),
                _createVNode(TextField, {
                  model: notaryCity.value,
                  "onUpdate:model": _cache[21] || (_cache[21] = ($event: any) => ((notaryCity).value = $event)),
                  type: "text",
                  name: "notary_city",
                  label: "Ciudad de notaría",
                  "has-error": notaryCityHasError.value,
                  "error-message": "Debe ingresar el nombre de la ciudad de la notaría",
                  placeholder: "Ej: 'Viña del mar'",
                  "hide-details": ""
                }, null, 8, ["model", "has-error"]),
                _createVNode(TextField, {
                  model: repertoireNumber.value,
                  "onUpdate:model": _cache[22] || (_cache[22] = ($event: any) => ((repertoireNumber).value = $event)),
                  type: "text",
                  name: "repertoireNumber",
                  label: "Número de repertorio",
                  "has-error": repertoireNumberHasError.value,
                  "error-message": "Debe ingresar el número de repertorio",
                  placeholder: "Ej: '2425/2022' o '2425'",
                  "hide-details": ""
                }, null, 8, ["model", "has-error"])
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["flex text-sm font-semibold", {
              'text-red-500': writingDateHasError.value,
              'text-gray-700': !writingDateHasError.value,
            }]),
                for: "datepicker"
              }, " Fecha de la escritura ", 2),
              _createVNode(_component_Datepicker, {
                modelValue: writingDate.value,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((writingDate).value = $event)),
                flow: flow.value,
                format: "dd/MM/yyyy",
                locale: "es",
                "enable-time-picker": false,
                placeholder: "Fecha de cuando se otorgó la escritura pública",
                cancelText: 'Cancelar',
                selectText: 'Seleccionar'
              }, null, 8, ["modelValue", "flow"])
            ])
          ]))
        : _createCommentVNode("", true),
      (textError.value != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("h3", _hoisted_19, _toDisplayString(textError.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "success btn ml-auto",
        onClick: registerShareholder,
        disabled: formHasError.value
      }, " Registrar ", 8, _hoisted_20)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})